/*
  ==========================================================================
  TAPP AIRSOFT - SALE PRICES + CAMPAIGN MESSAGES  (assets/tapp-sale-prices.js)
  ==========================================================================
  One schedule (PHASES below) drives three things, and each one switches by
  itself at the exact times listed:

  1. PRICES. While a sale is on, every product price on the site shows the
     regular price crossed out next to the sale price (product pages,
     collections, search, featured sections, quick add), and product cards
     get a "Sale" badge.
  2. ANNOUNCEMENT BAR. The announcement that holds the sale message (today:
     "BLACK FRIDAY - 10% Auto Applied at Checkout!") shows the message for
     the current phase. If you type a different message into that
     announcement in the theme editor, this leaves your message alone. After
     the last phase it is hidden and the other announcements keep rotating.
  3. HOMEPAGE BUILDERS. The sale banner in the hero sentence builder and in
     the Step Builder shows the current phase's name and note. The builders
     still do their own price math; their percent matches PHASES.

  DISPLAY ONLY. The actual price cut is the automatic discount in Shopify
  admin > Discounts. If you change a discount's dates or percent there,
  change the matching lines below too.

  Times are US Eastern. -04:00 = daylight time, -05:00 = standard time.

  Load this file without "defer" in theme.liquid so the announcement bar
  shows the right message from the first moment the page appears.
  ==========================================================================
*/
(function () {
  'use strict';

  var PHASES = [
    { start: '2026-11-01T00:00:00-04:00', end: '2026-11-27T00:00:00-05:00', percent: 10, discount: 'BlackFriday10',
      bar: 'BLACK FRIDAY - 10% Auto Applied at Checkout!',
      title: 'Black Friday', note: '' },
    { start: '2026-11-27T00:00:00-05:00', end: '2026-11-30T00:00:00-05:00', percent: 20, discount: 'BlackFriday20',
      bar: 'BLACK FRIDAY - 20% Off Everything, Our Largest Sale of the Year!',
      title: 'Black Friday', note: 'largest sale of the year' },
    { start: '2026-11-30T00:00:00-05:00', end: '2026-12-01T00:00:00-05:00', percent: 20, discount: 'BlackFriday20',
      bar: 'CYBER MONDAY - 20% Off Ends Tonight at 11:59 PM ET!',
      title: 'Cyber Monday', note: 'ends tonight at 11:59 PM ET' },
    { start: '2026-12-01T00:00:00-05:00', end: '2026-12-21T00:00:00-05:00', percent: 10, discount: 'Holiday10',
      bar: 'BLACK FRIDAY EXTENDED - 10% Off, Order Now for Christmas!',
      title: 'Black Friday, Extended', note: 'order now for Christmas' },
    { start: '2026-12-21T00:00:00-05:00', end: '2026-12-25T00:00:00-05:00', percent: 10, discount: 'Holiday10',
      bar: 'LAST DAYS - 10% Off Ends Christmas Day!',
      title: 'Holiday Sale', note: 'last days, ends Christmas Day' },
    { start: '2026-12-25T00:00:00-05:00', end: '2026-12-26T00:00:00-05:00', percent: 10, discount: 'Holiday10',
      bar: 'MERRY CHRISTMAS - 10% Off Ends Tonight!',
      title: 'Merry Christmas', note: 'ends tonight' },
    { start: '2026-12-26T00:00:00-05:00', end: '2026-12-31T00:00:00-05:00', percent: 20, discount: 'YearEnd20',
      bar: 'SURPRISE SALE - 20% Off Everything, Ends Any Day!',
      title: 'Surprise Sale', note: 'ends any day' },
    { start: '2026-12-31T00:00:00-05:00', end: '2027-01-04T00:00:00-05:00', percent: 20, discount: 'YearEnd20',
      bar: "NEW YEAR'S SALE - 20% Off Everything, Ends Any Day!",
      title: "New Year's Sale", note: 'ends any day' },
    { start: '2027-01-04T00:00:00-05:00', end: '2027-01-05T00:00:00-05:00', percent: 20, discount: 'YearEnd20',
      bar: 'FINAL HOURS - 20% Off Ends Tonight at 11:59 PM ET!',
      title: 'Final Hours', note: 'ends tonight at 11:59 PM ET' }
  ];

  var BADGE_TEXT = 'Sale';             // product-card badge text. '{percent}% OFF' shows e.g. "20% OFF"
  var BADGE_COLOR = 'color-scheme-4';  // same color scheme as your theme's Sale badge
  var FROM_WORD = 'From';              // the word your theme shows before "From $X" prices

  // Sale banners inside the homepage builders, and the words each one ends with.
  var BUILDER_BANNERS = [
    { id: 'thb-sale', tail: 'applied at checkout' },               // hero sentence builder
    { id: 'tab-sale', tail: 'applied automatically at checkout' }  // Step Builder
  ];

  /* ----------------------- nothing to edit below ----------------------- */

  if (window.__tappSalePrices) return;
  window.__tappSalePrices = true;
  if (!window.WeakMap || !window.MutationObserver || !Element.prototype.closest) return;

  function norm(t) {
    return String(t || '').replace(/[‘’]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
  }

  var LIST = [], BAR_TEXTS = {};
  for (var n = 0; n < PHASES.length; n++) {
    var s0 = PHASES[n];
    var a = Date.parse(s0.start), b = Date.parse(s0.end), p = Number(s0.percent);
    if (!isNaN(a) && !isNaN(b) && b > a && p > 0 && p < 100) {
      LIST.push({
        start: a, end: b, percent: p,
        name: String(s0.discount || p + '%'),
        bar: String(s0.bar || ''), title: String(s0.title || ''), note: String(s0.note || '')
      });
      if (s0.bar) BAR_TEXTS[norm(s0.bar)] = true;
    }
  }

  function phaseAt(now) {
    for (var i = 0; i < LIST.length; i++) {
      if (now >= LIST[i].start && now < LIST[i].end) return LIST[i];
    }
    return null;
  }

  function nextChange(now) {
    var t = Infinity;
    for (var i = 0; i < LIST.length; i++) {
      if (LIST[i].start > now && LIST[i].start < t) t = LIST[i].start;
      if (LIST[i].end > now && LIST[i].end < t) t = LIST[i].end;
    }
    return t;
  }

  /* ---------- announcement bar ---------- */

  function resetSlider(el) {
    var slider = el.closest('slideshow-component, slider-component');
    if (slider && typeof slider.resetPages === 'function') {
      try { slider.resetPages(); } catch (e) { /* the slider fixes itself on the next resize */ }
    }
  }

  // The announcement(s) whose text is one of the sale messages above.
  function barSlots() {
    var out = [], msgs = document.querySelectorAll('.announcement-bar__message');
    for (var i = 0; i < msgs.length; i++) {
      var span = msgs[i].querySelector('span');
      if (!span) continue;
      if (msgs[i].getAttribute('data-tapp-sale-slot') !== '1') {
        if (!BAR_TEXTS[norm(span.textContent)]) continue;
        msgs[i].setAttribute('data-tapp-sale-slot', '1');
      }
      out.push({ span: span, slide: msgs[i].closest('.slideshow__slide') });
    }
    return out;
  }

  function updateBar(phase) {
    var slots = barSlots();
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      if (phase) {
        if (s.span.textContent !== phase.bar) s.span.textContent = phase.bar;
        if (s.slide && s.slide.hasAttribute('data-tapp-hidden')) {
          s.slide.removeAttribute('data-tapp-hidden');
          resetSlider(s.slide);
        }
      } else if (s.slide && !s.slide.hasAttribute('data-tapp-hidden') && s.slide.parentNode) {
        // No sale: hide the sale message, as long as other announcements are left to show.
        var shown = s.slide.parentNode.querySelectorAll('.slideshow__slide:not([data-tapp-hidden])').length;
        if (shown > 1) {
          s.slide.setAttribute('data-tapp-hidden', '');
          resetSlider(s.slide);
        }
      }
    }
  }

  /* ---------- sale banners in the homepage builders ---------- */

  function updateBuilders(phase) {
    if (!phase) return;
    for (var i = 0; i < BUILDER_BANNERS.length; i++) {
      var el = document.getElementById(BUILDER_BANNERS[i].id);
      if (!el || el.hidden) continue;                    // the builder shows no sale right now
      var label = el.querySelector('b'), line = el.querySelector('span');
      if (!label || !line) continue;
      // The builder priced everything at its own percent when the page loaded. If that is not this
      // phase's percent (the page stayed open across a switch), leave its banner matching its prices.
      if (line.textContent.indexOf(phase.percent + '%') !== 0) continue;
      var text = phase.percent + '% off every adapter & drum' +
        (phase.note ? ' · ' + phase.note : '') + ' · ' + BUILDER_BANNERS[i].tail;
      if (label.textContent !== phase.title) label.textContent = phase.title;
      if (line.textContent !== text) line.textContent = text;
    }
  }

  /* ---------- money: works with $1,234.56 / EUR 1.234,56 / JPY 15,000 / CHF 1'234.50 ---------- */

  var NUM = /\d(?:[\d.,'   ]*\d)?/g;

  function parseAmount(run) {
    var seps = [], i;
    for (i = 0; i < run.length; i++) {
      var c = run.charAt(i);
      if (c < '0' || c > '9') seps.push({ c: c, i: i });
    }
    var dec = '', decimals = 0, intPart = run, frac = '';
    if (seps.length) {
      var last = seps[seps.length - 1];
      var after = run.length - last.i - 1;
      if ((last.c === '.' || last.c === ',') && after > 0 && after < 3) {
        dec = last.c;
        decimals = after;
        intPart = run.slice(0, last.i);
        frac = run.slice(last.i + 1);
        seps.pop();
      }
    }
    var thou = seps.length ? seps[0].c : '';
    for (i = 0; i < seps.length; i++) {
      if (seps[i].c !== thou) return null;              // mixed separators: not a price
    }
    if (thou) {
      var groups = intPart.split(thou);
      for (i = 1; i < groups.length; i++) {
        if (groups[i].length !== 3) return null;          // 1,23 etc: not a price
      }
    }
    var value = parseInt(intPart.replace(/\D/g, '') + frac, 10);
    if (isNaN(value)) return null;
    return { value: value, decimals: decimals, dec: dec, thou: thou };
  }

  function formatAmount(value, f) {
    var pow = Math.pow(10, f.decimals);
    var whole = String(Math.floor(value / pow));
    var frac = String(value % pow);
    while (frac.length < f.decimals) frac = '0' + frac;
    if (f.thou) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
    return whole + (f.decimals ? f.dec + frac : '');
  }

  // "$1,234.56 USD" -> same text with the sale amount, or null if there is no amount in it
  function saleText(text, percent) {
    var changed = false;
    var out = text.replace(NUM, function (run) {
      var f = parseAmount(run);
      if (!f || f.value <= 0) return run;
      changed = true;
      return formatAmount(f.value - Math.round(f.value * percent / 100), f);
    });
    return changed ? out : null;
  }

  function clean(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function stripFrom(t) {
    return FROM_WORD && t.indexOf(FROM_WORD + ' ') === 0 ? t.slice(FROM_WORD.length + 1) : t;
  }

  function child(el, cls) {
    for (var c = el.firstElementChild; c; c = c.nextElementSibling) {
      if (c.classList.contains(cls)) return c;
    }
    return null;
  }

  /* ---------- product card "Sale" badge ---------- */

  function addBadges(el, sale) {
    var card = el.closest('.card-wrapper');
    if (!card) return;
    var slots = card.querySelectorAll('.card__badge');
    var label = BADGE_TEXT.replace('{percent}', sale.percent);
    for (var i = 0; i < slots.length; i++) {
      var mine = slots[i].querySelector('.tapp-sale-badge');
      if (mine) {
        if (mine.textContent !== label) mine.textContent = label;
        continue;
      }
      if (slots[i].querySelector('.badge')) continue;     // already "Sold out" or a real "Sale" badge
      var badge = document.createElement('span');
      badge.className = 'badge badge--bottom-left ' + BADGE_COLOR + ' tapp-sale-badge';
      badge.textContent = label;
      slots[i].appendChild(badge);
    }
  }

  function removeBadges(el) {
    var card = el.closest('.card-wrapper');
    if (!card) return;
    var mine = card.querySelectorAll('.tapp-sale-badge');
    for (var i = 0; i < mine.length; i++) mine[i].parentNode.removeChild(mine[i]);
  }

  /* ---------- one theme price block ---------- */

  var STATE = new WeakMap();

  function restore(el, st) {
    if (st.view && st.view.parentNode) st.view.parentNode.removeChild(st.view);
    st.view = null;
    st.key = null;
    el.classList.remove('tapp-sale-on');
    if (!st.native) el.classList.remove('price--on-sale');
    if (st.noCompare) el.classList.add('price--no-compare');
    removeBadges(el);
  }

  function processPrice(el, sale) {
    var box = child(el, 'price__container');
    var reg = box && child(box, 'price__regular');
    var orig = box && child(box, 'price__sale');
    if (!reg || !orig) return;

    var st = STATE.get(el);
    if (!st) {
      if (!sale) return;
      if (el.classList.contains('volume-pricing--sale-badge') || reg.querySelector('.variant-item__old-price')) return;
      st = {
        native: el.classList.contains('price--on-sale'),   // already on sale with a compare-at price
        noCompare: el.classList.contains('price--no-compare'),
        renders: 0
      };
      STATE.set(el, st);
    }
    if (st.dead) return;
    if (!sale) {
      if (st.key) restore(el, st);
      return;
    }

    var now, was;
    if (st.native) {
      now = clean(orig.querySelector('.price-item--sale'));
      was = clean(orig.querySelector('s')) || stripFrom(now);
    } else {
      now = clean(reg.querySelector('.price-item--regular'));
      was = stripFrom(now);
    }
    var key = sale.name + '|' + sale.percent + '|' + now + '|' + was;
    if (st.key === key && st.view && st.view.parentNode === box) {
      var shownWas = st.view.querySelector('s'), shownCut = st.view.querySelector('.price-item--sale');
      if (shownWas && shownCut && shownWas.textContent === st.was && shownCut.textContent === st.cut) return;   // already showing this
    }
    if (st.renders > 60) {            // something keeps rewriting this price: give it back to the theme
      restore(el, st);
      st.dead = true;
      return;
    }

    var cut = now && saleText(now, sale.percent);
    if (!cut || cut === now) {
      if (st.key) restore(el, st);
      return;
    }

    var view = st.view;
    if (!view || view.parentNode !== box) {
      view = orig.cloneNode(true);
      view.classList.add('tapp-sale-view');
      if (!view.querySelector('s')) {
        var wrap = document.createElement('span');
        var strike = document.createElement('s');
        strike.className = 'price-item price-item--regular';
        wrap.appendChild(strike);
        view.insertBefore(wrap, view.firstChild);
      }
      box.insertBefore(view, orig.nextSibling);
      st.view = view;
    }
    var saleItem = view.querySelector('.price-item--sale');
    if (!saleItem) {
      restore(el, st);
      return;
    }
    view.querySelector('s').textContent = was;
    saleItem.textContent = cut;
    el.classList.add('price--on-sale', 'tapp-sale-on');
    el.classList.remove('price--no-compare');
    st.key = key;
    st.was = was;
    st.cut = cut;
    st.renders++;
    addBadges(el, sale);
  }

  /* ---------- run on load, on page changes, and at each switch time ---------- */

  function scan() {
    var phase = phaseAt(Date.now());
    try { updateBar(phase); } catch (e) { /* leave the bar as the theme rendered it */ }
    try { updateBuilders(phase); } catch (e) { /* leave the builder banners as they are */ }
    var boxes = document.querySelectorAll('.price > .price__container');
    for (var i = 0; i < boxes.length; i++) {
      try {
        processPrice(boxes[i].parentNode, phase);
      } catch (e) {
        /* leave this price as the theme rendered it */
      }
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      scan();
    }, 30);
  }

  var timer = null;
  function arm() {
    clearTimeout(timer);
    var now = Date.now(), next = nextChange(now);
    if (next === Infinity) return;
    timer = setTimeout(function () {
      scan();
      arm();
    }, Math.min(next - now + 500, 6 * 60 * 60 * 1000));
  }

  function refresh() {
    scan();
    arm();
  }

  var style = document.createElement('style');
  style.textContent =
    '.price.tapp-sale-on>.price__container>.price__regular,' +
    '.price.tapp-sale-on>.price__container>.price__sale:not(.tapp-sale-view){display:none!important}' +
    '.slideshow__slide[data-tapp-hidden]{display:none!important}';
  (document.head || document.documentElement).appendChild(style);

  // While the page is still loading, catch the announcement bar the moment it arrives so the
  // sale message is right before anything is drawn on screen.
  if (document.readyState === 'loading') {
    var early = new MutationObserver(function () {
      try { updateBar(phaseAt(Date.now())); } catch (e) { /* the full run below tries again */ }
      if (document.querySelector('.section-header, main')) early.disconnect();
    });
    early.observe(document.documentElement, { childList: true, subtree: true });
  }

  function start() {
    // Re-check whenever the page changes: variant picked, add-on options (Easify) changing the price,
    // more products loaded by filters or recommendations. Unchanged prices are skipped, so this is cheap.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.nodeType !== 1) t = t.parentNode;
        if (t && t.closest && t.closest('.tapp-sale-badge')) continue;
        queue();
        return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    refresh();
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });

  // For other code on the site:
  //   window.TappSale.active() -> { percent, name, start, end } or null   (name = Shopify discount)
  //   window.TappSale.phase()  -> the current PHASES entry with its messages, or null
  window.TappSale = {
    active: function () {
      var ph = phaseAt(Date.now());
      return ph ? { percent: ph.percent, name: ph.name, start: ph.start, end: ph.end } : null;
    },
    phase: function () { return phaseAt(Date.now()); },
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
